import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from "preact";
import { currencyFormat } from "../../util/Formatter";
export default class PreserveOptionComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            singleOption: null,
            multipleOption: []
        };
    }
    render() {
        const preserveStart = this.props.preserveStart;
        const singleOptions = this.props.planGroup?.singleOptions ?? [];
        const multipleOptions = this.props.planGroup?.multipleOptions ?? [];
        const visible = (singleOptions.length > 0 || multipleOptions.length > 0) && preserveStart !== null;
        return (_jsxs("section", Object.assign({ className: `SchedulePayComponent__container ${visible ? '' : 'hide'}`, id: "PreserveOptionComponent" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u4EFB\u610F\u3067\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8A2D\u5B9A\u53EF\u80FD\u3067\u3059"] }), void 0),
                _jsxs("div", Object.assign({ class: "control field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u3053\u3061\u3089\u306F\u4E00\u3064\u3060\u3051\u304A\u9078\u3073\u9802\u3051\u307E\u3059" }), void 0),
                        _jsx("ul", Object.assign({ class: "ml3" }, { children: singleOptions.map(m => {
                                return (_jsx("li", { children: _jsxs("label", Object.assign({ class: "radio" }, { children: [_jsx("input", { type: "radio", name: "singleOption", class: "mr1", onInput: () => this.setSingleOption(m) }, void 0), m.name, "(", currencyFormat(m.price), ")"] }), void 0) }, void 0));
                            }) }), void 0)] }), void 0),
                _jsxs("div", Object.assign({ class: "control field" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u3053\u3061\u3089\u306F\u8907\u6570\u304A\u9078\u3073\u9802\u3051\u307E\u3059" }), void 0),
                        _jsx("ul", Object.assign({ class: "ml3" }, { children: multipleOptions.map(m => {
                                return (_jsx("li", { children: _jsxs("label", Object.assign({ class: "checkbox" }, { children: [_jsx("input", { type: "checkbox", name: "multipleOption", class: "mr1", onInput: () => this.setMultipleOption(m) }, void 0), m.name, "(", currencyFormat(m.price), ")"] }), void 0) }, void 0));
                            }) }), void 0)] }), void 0)] }), void 0));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.planGroup === null) {
            this.setState({
                singleOption: null,
                multipleOption: []
            });
        }
    }
    setSingleOption(option) {
        this.setState({
            singleOption: option
        });
        this.props.singleOptionSetter(option);
    }
    setMultipleOption(option) {
        let options = this.state.multipleOption;
        const count = options.filter(p => p.id === option.id).length;
        if (count === 0) {
            options.push(option);
        }
        else {
            options = options.filter(p => p.id !== option.id);
        }
        this.setState({
            multipleOption: options
        });
        this.props.multipleOptionSetter(options);
    }
}
